import styled from "styled-components";
import { GatsbyImage as GatsbyImageInternal } from "gatsby-plugin-image";

export const GatsbyImage = styled(GatsbyImageInternal).attrs({ alt: "" })``;
export const NativeImage = styled.img`
  object-fit: ${({ object_fit }) => object_fit} !important;
`;
